import { Component } from '@angular/core';

@Component({
  selector: 'playbook-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'playbook-authentication-frontend';
}
